export function CountyZoningAndFloodPlainPermits() {
    return `<table class="esri-widget__table" summary="List of attributes and values">
          <tbody>
              <tr>
                  <th class="third">Permit Type</th>
                  <td class="two-third">{Permit Type}</td>
              </tr>
              <tr>
                  <th class="third">Permit Number</th>
                  <td class="two-third">{Permit Number}</td>
              </tr>
              <tr>
                  <th class="third">Approval Date</th>
                  <td class="two-third">{Approval Date}</td>
              </tr>
              <tr>
                  <th class="third">Other Information</th>
                  <td class="two-third">{Other Information}</td>
              </tr>
              <tr>
                  <th class="third">Application</th>
                  <td class="two-third">
                      <a target="_blank" href="{Image}" class="ui fluid tiny button">View PDF</a>
                  </td>
              </tr>
          </tbody>
      </table>`;
  }
  